import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Grid, Container, Typography } from '@mui/material'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import { TableDataPresentation, ListDataPresentation } from '../../../utils/utils'
import MainTitle from '../../muiHome/mainTitle'
import NewMain from '../../headerone/newMain'
function ScholarshipNew() {
	 


	return (
		<>
			<NewMain />
			<Bredcom title="Home" subtitle="Fee Structure With Eligibility 2025-26" />
			<Container>



				<h3 class="newtitle">Scholarship Policy: A.Y. 2026-27			
	</h3>

 

				  

				<div className='containe_tedxt scholerpship_list'>
					 <br/>
					<h4> CATEGORY - A</h4>

					{/** new code  */}
					<h5 className='table_had'>SUB - CATEGORY - A1	 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>Meritorious Scholarship (Qualifying examination Marks/CGPA</th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Qualifying Examination Marks/CGPA</strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>

							<tr>
                                    <td>1</td>
                                    <td>95% and above</td>
                                    <td>50% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>90% and above but below 95%</td>
                                    <td>40% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>85% and above but below 90%</td>
                                    <td>25% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>80% and above but below 85%</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>75% and above but below 80%</td>
                                    <td>15% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>65% and above but below 75%</td>
                                    <td>10% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>EWS/BPL</td>
                                    <td>N/A</td>
                                </tr>
							 
						</tbody>
					</table>

					<p>Note: One time, at the time of Admission only			</p>


					<h5 className='table_had'>SUB - CATEGORY - A2	 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>JEE - Mains All India Rank </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>

							 <tr>
                                    <td>1</td>
                                    <td>Upto 150000</td>
                                    <td>50% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>150001 - 250000</td>
                                    <td>25% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>250001 - 400000</td>
                                    <td>10% Tuition fee waiver</td>
                                </tr>

							 
							 
						</tbody>
					</table>

					<p>Note: One time, at the time of Admission only		</p>


					<h5 className='table_had'> SUB - CATEGORY - A3 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>CUET 2026 Marks/Score (Diploma, UG, PG Courses) </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>CUET Marks/Score </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>
  <tr>
                                    <td>1</td>
                                    <td>95% and above</td>
                                    <td>100% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>85% and above but below 95%</td>
                                    <td>50% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>75% and above but below 85%</td>
                                    <td>25% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>50% and above but below 75%</td>
                                    <td>15% Tuition Fee waiver</td>
                                </tr>

							 
							 
						</tbody>
					</table>

					<p> 	Note: One time, at the time of Admission only</p>



					<h5 className='table_had'> SUB - CATEGORY - A4 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>CLAT 2025/26 Score/Marks </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>CLAT Marks/Score </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>
  <tr>
                                    <td>1</td>
                                    <td>101 &amp; above</td>
                                    <td>90% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>91 to 100</td>
                                    <td>50% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>70 to 90</td>
                                    <td>25% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>50 to 70</td>
                                    <td>10% Tuition Fee waiver</td>
                                </tr>

							 
							 
						</tbody>
					</table>

					<p> 	Note: One time, at the time of Admission only</p>

					<h5 className='table_had'>  SUB - CATEGORY - A5 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>CAT/MAT/CMAT/ATMA 2025/26 Score/Marks </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>CAT/MAT/CMAT/ATMA-2024 Score/Marks </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>
 

							 <tr>
                                    <td>1</td>
                                    <td>80% and above</td>
                                    <td>100% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>71% to 79.99%</td>
                                    <td>50% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>50% to 70.99%</td>
                                    <td>25% Tuition Fee waiver</td>
                                </tr>
							 
						</tbody>
					</table>

					<p> Note: One time, at the time of Admission only	</p>


					<h5 className='table_had'> SUB - CATEGORY - A6 </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> Scholarship for Sports category</th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Event/Level </strong></td>
								<td><strong>Participation </strong></td>
								<td><strong> Medal Winner </strong></td>
							</tr>

							<tr>
                                    <td>1</td>
                                    <td>Olympics</td>
                                    <td>100% Tuition Fee waiver</td>
                                    <td>100% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Asian Games / Asian Championship</td>
                                    <td>75% Tuition Fee waiver</td>
                                    <td>100% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Common Wealth Games</td>
                                    <td>50% Tuition Fee waiver</td>
                                    <td>75% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>World Cup</td>
                                    <td>50% Tuition Fee waiver</td>
                                    <td>75% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>National</td>
                                    <td>50% Tuition Fee waiver</td>
                                    <td>75% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>State (with compulsory participation in National)</td>
                                    <td>25 % Tuition Fee waiver</td>
                                    <td>50% Tuition Fee waiver</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>School/College/District</td>
                                    <td>10% Tuition Fee waiver</td>
                                    <td></td>
                                </tr>


							 
							 
						</tbody>
					</table>

					<p> 	Note: One time, at the time of Admission only</p>

					<h5 className='table_had'> CATEGORY - B </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> Over &amp; Above (Special Scholarships Schemes ) </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Category/Particulars </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr>
 
 <tr>
                                    <td>1</td>
                                    <td>
                                        12th Pass from MVN School / UG to PG in MVNU / Siblings of MVNU Student / Wards
                                        of MVNU Employee
                                    </td>
                                    <td>05% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Defence Personnel</td>
                                    <td>05% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>NCC/NSS/Bharat Scouts and Guides</td>
                                    <td>05% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Lateral Entry Admissions (All Program)</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Person with a disability (PWD)</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>
							 
							 
						</tbody>
					</table>

					<p> 	Note: One time, at the time of Admission only</p>


					<h5 className='table_had'>CATEGORY - C (Applicable only one category A/C/D)   </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> Special Scholarships for Orphans, Single-Parent Child and Poor Girls Child  </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Category/Particulars </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr> 


							 <tr>
                                    <td>1</td>
                                    <td>
                                        Sh. Gopal Sharma Scholarship and Mentorship scheme for Poor / Underprivileged
                                        Girls child (for Palwal, Mewat, Faridabad, Gurugram, Aligarh &amp; Mathura
                                        District) (poor girl child)
                                    </td>
                                    <td>
                                        Upto 50% Tuition fee waiver (Scholarships will be decided by the university
                                        admissions committee after verification of Income &amp; Domicile documents and
                                        physical verification only ). Family income is less than or equal to 5 Lakhs.
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>
                                        Sh. Gopal Sharma Scholarship and Mentorship scheme for Orphans &amp;
                                        Single-Parent Child
                                    </td>
                                    <td>
                                        Upto 50% Tuition fee waiver (Scholarships will be decided by the university
                                        admissions committee after verification of all relevant documents and physical
                                        verification. )
                                    </td>
                                </tr>



							 
							 
						</tbody>
					</table>

					<p> 	Note: Above Scholarships schemes are applicable for all courses. Overall family income is
                            not more than 5 Lacs. Applicant will not be entitled for any other scholarship</p>


					<h5 className='table_had'> CATEGORY - D (Applicable only one category A/C/D)  </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> Special Rebate / Concession for Khambi village Girl child  </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Qualifying Examination Marks/CGPA </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr> 

							<tr>
                                    <td>1</td>
                                    <td>50% and above</td>
                                    <td>80% Tuition fee waiver</td>
                                </tr>


							 
							 
						</tbody>
					</table>

					<p>Note: One time, at the time of Admission only, except B.Pharm, Pharm.D, BPT, B.Tech CSE
                            (AIML) &amp; BA LLB</p>


					<h5 className='table_had'> CATEGORY - E  </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>  Scholarships for Ph.D </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Category/Particulars </strong></td>
								<td><strong>Scholarship (Any one is applicable) </strong></td>
							</tr> 


							 <tr>
                                    <td>1</td>
                                    <td>MVN Society Staff/ Ward of MVN Society Satff</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>UG / PG from MVN University</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Person with a disability (PWD)</td>
                                    <td>20% Tuition fee waiver</td>
                                </tr>


							 
							 
						</tbody>
					</table>

					<p> 	Note: Applicable upto 3rd year only and only one scholarship is applicable</p>


					<h5 className='table_had'> CATEGORY - F  </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>  MVNU Ignitia Test Rankers </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td  colSpan={3}> <strong> Students who have appeared for MVNU Ignitia from each School shall be eligible for a 10% tution fee waiver scholarship, in addition to the scholarship offered by MVNU based on academic performance in the qualifying board exam.			
</strong></td>
								 
							</tr> 
							 
							 
						</tbody>
					</table>
 

					<h5 className='table_had'>  CATEGORY - G  </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}>Swami Dayanand Education Foundation Merit-cum-Means Scholarships to exceptionally talented but
                        poor students   </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Name of Program </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr> 
							   <tr>
                                    <td>1</td>
                                    <td>Any Program/Course</td>
                                    <td>Upto Rs. 25000/- Rs scholarship for 1st 10 Students</td>
                                </tr>
							 
						</tbody>
					</table>

					<p> 	Note: Terms &amp; Conditions Applicable.</p>


					<h5 className='table_had'> CATEGORY - H  </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						<thead>
							<tr>
								<th colSpan={3}> Special Scholarship for Girl Child (All Programs)  </th>

							</tr>
						</thead>
						<tbody>
							<tr>
								<td><strong> S. No. </strong></td>
								<td><strong>Name of Program </strong></td>
								<td><strong>Scholarship </strong></td>
							</tr> 

							<tr>
                                    <td>1</td>
                                    <td>Girl Child</td>
                                    <td>15% Tution Fee waiver</td>
                                </tr>


							 
							 
						</tbody>
					</table>

					<p> 	Note: Terms &amp; Conditions Applicable</p>

					<h5 className='table_had'>CATEGORY - I (2nd year onwards)   </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table>
						 
						<tbody>
							<tr>
								<td colSpan={3}><strong>   2nd year onwards meritorious scholarship will be applicable for all (Diploma, UG &amp; PG)
                        student. The rules for meritorious scholarship schemes are: (w.e.f. Admission Year 2026-27) </strong></td>
								 
							</tr> 
							 
							 
						</tbody>
					</table>


					<h5 className='table_had'> Eligibility Conditions for 2nd year onwards scholarships </h5>
					<h5 className='table_hadwith_bg'></h5>
					<table class="text-left	">
						 
						<tbody>
							<tr>
                                    <td>(i)</td>
                                    <td>No Indiscpline in any matter during the year of study.</td>
                                </tr>

								 <tr>
                                    <td>(i)</td>
                                    <td>85% attendance in all subjects</td>
                                </tr>

								<tr>
                                    <td>(iii)</td>
                                    <td className='bottom_border_table'>
										<table >

											<tbody>
													<tr>
														<td> (a) 8.0 CGPA - 8.49 CGPA in each Semester/Year                          :  20% Tution Fee Waiver		
</td> 
													</tr>

													<tr>
														<td>(b) 8.5 CGPA - 8.99 CGPA in each Semester/Year                          :  25% Tution Fee Waiver		
 </td> 
													</tr>


<tr>
														<td>(c) 9.0 CGPA - 9.49 CGPA in each Semester/Year                          :  40% Tution Fee Waiver		
 </td> 
													</tr>


<tr>
														<td>(d) 9.5 CGPA - 10 CGPA in each Semester/Year                             :  50% Tution Fee Waiver		
 </td> 
													</tr>


											</tbody>
										</table>


									</td>
                                </tr>

								<tr>
                                    <td>Note:

</td>
                                    <td> 
									   The benefits of the scholarship will be given in two equal installments, i.e., equally divided over two semesters. 		

<br/> 
Scholarships shall be applicable only during the prescribed course duration		


											
									</td>
                                </tr>






							 
							 
						</tbody>
					</table>

					<p> 	Note: Terms &amp; Conditions Applicable</p>




				 


 



 


				</div>

 




			</Container>


		</>
	)
}

export default ScholarshipNew